<template>
  <div>
    <Header />
    <IQOSHorizontalScrollWithActions>
      <MarketingCategoryCard v-model="marketing_mode" type="campaigns" />
      <MarketingCategoryCard v-model="marketing_mode" type="loyalty" />
      <MarketingCategoryCard v-model="marketing_mode" type="promocodes" />
      <MarketingCategoryCard v-model="marketing_mode" type="discounts" />

      <template #actions>
        <BaseButton
          v-if="marketing_mode == 'campaigns'"
          variant="secondary"
          color="v1-grey-10"
          icon="plus"
          @click="onTopAction"
          class="add-btn"
          size="md"
        >
          {{ $t("campaigns_view.add_btn") }}</BaseButton
        ><BaseButton
          v-if="marketing_mode == 'promocodes'"
          variant="secondary"
          color="v1-grey-10"
          class="add-btn"
          size="md"
          icon="plus"
          @click="onTopAction"
          >{{ $t("promocode_add_modal.show_btn") }}</BaseButton
        >
        <BaseButton
          v-if="marketing_mode == 'discounts'"
          icon="plus"
          variant="secondary"
          size="md"
          color="v1-grey-10"
          class="add-btn"
          @click="onTopAction"
          >{{ $t("add_discount.btn") }}</BaseButton
        >
      </template>
    </IQOSHorizontalScrollWithActions>
    <BaseDivider color="v1-grey-3" />
    <PageContainer :topPadding="24">
      <div>
        <CampaignsView
          ref="campaignsView"
          v-if="marketing_mode == 'campaigns'"
        />
        <LoyaltyView v-else-if="marketing_mode == 'loyalty'" />
        <PromocodesView
          ref="promocodesView"
          v-else-if="marketing_mode == 'promocodes'"
        />
        <DiscountsView
          ref="discountsView"
          v-else-if="marketing_mode == 'discounts'"
        />
      </div>
    </PageContainer>
  </div>
</template>

<script>
import ReferralsAPI from "@/api/referrals";
import DashboardButton from "@/components/DashboardButton.vue";
// import AddCampaignPop/Up from "@/components/marketing/AddCampaignPopUp.vue";
import GenaretePromo from "@/components/marketing/GenaretePromo.vue";
import PopUp from "@/components/PopUp.vue";

import CampaignCard from "@/components/marketing/CampaignCard.vue";
import AdvertisingCampaign from "@/components/marketing/AdvertisingCampaign.vue";
import AddCampaignCard from "@/components/marketing/AddCampaignCard.vue";
import BlackInput from "@/components/BlackInput.vue";
import BlackSelect from "@/components/BlackSelect.vue";
import IQOS from "@/components/IQOS.vue";

import IQOSToggle from "@/components/IQOSToggle.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import CashbackPanel from "@/components/marketing/CashbackPanel.vue";

import NewtonPromotion from "@/components/promotions/NewtonPromotion.vue";

import CampaignsView from "@/components/marketing/CampaignsView.vue";
import PromocodesView from "@/components/marketing/PromocodesView.vue";
import LoyaltyView from "@/components/marketing/LoyaltyView.vue";
import DiscountsView from "@/components/marketing/DiscountsView.vue";

import MarketingCategoryCard from "@/components/marketing/MarketingCategoryCard.vue";

import moment from "moment";

export default {
  data() {
    return {
      campaigns: [],
      adding: {
        active: false,
        title: null,
        period: null,
      },
      marketing_mode: "campaigns",
      popup: false,
      btn_icon: "add-icon2",
    };
  },
  methods: {
    onAddCampaign(data) {
      this.adding.title = data.title;
      this.adding.period = data.period;
      if (!this.adding.title) return;

      ReferralsAPI.createCampaign(
        this.adding.title,
        this.adding.period.start,
        this.adding.period.end
      )
        .then((data) => {
          this.fetchCampaigns();
          this.adding.active = false;

          this.$store.dispatch("auditlog/write", {
            type: "marketing_new_campaign",
            payload: {
              title: this.adding.title,
            },
          });
        })
        .catch((error) => {
          this.$store.dispatch("showError", "referrals_error");
        });
    },
    onTopAction() {
      if (this.marketing_mode == "campaigns") {
        this.$refs.campaignsView.showAddCampaignUI();
      } else if (this.marketing_mode == "discounts") {
        this.$refs.discountsView.showAddPromotionUI();
      } else {
        // console.log(this.$refs.promocodesView)
        this.$refs.promocodesView.showAddPromocodeUI();
        this.$store.dispatch("menu/fetchMenus");
      }
    },
  },
  mounted() {},
  components: {
    CampaignCard,
    BlackInput,
    IQOSActions,
    CashbackPanel,
    AddCampaignCard,
    NewtonPromotion,
    DashboardButton,
    AdvertisingCampaign,
    IQOS,
    IQOSToggle,
    BlackSelect,
    PopUp,
    // AddCampaignPopUp,
    GenaretePromo,
    CampaignsView,
    LoyaltyView,
    PromocodesView,
    DiscountsView,
    MarketingCategoryCard,
  },
  computed: {
    showDrinkDiscount() {
      return (
        this.$store.state.cafe._id == 172 ||
        this.$store.state.cafe._id == 236 ||
        this.$store.state.cafe._id == 1
      );
    },
  },
};
</script>

<style scoped>
.ad-description {
  font-weight: normal;
  font-size: 2.22vh;
  line-height: 2.5555555555555554vh;
  color: #908f8d;
}
/* #marketing-row {
  max-width: 100%;
  overflow: auto;
  scroll-behavior: smooth;
} */
.marketing-items-container {
  display: table-row;
}

.marketing-items {
  width: auto;

  display: flex;
}
.marketing-item.active-item {
  opacity: 1;
}
.marketing-item {
  width: 42.333333333333336vh;
  height: 17.333333333333332vh;
  border-radius: 1.1111111111111112vh;
  opacity: 0.7;
  position: relative;
  margin-right: 2.22vh;
  transition: opacity 0.3s;
  cursor: pointer;
}
.marketing-item img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1.1111111111111112vh;
}
.marketing-item div {
  font-size: 2.222vh;
  color: #ededed;
  padding: 2.222vh;
  width: 100%;
  box-sizing: border-box;
  position: absolute;
  z-index: 2;
}
.marketing-items-controll {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.arrow-container {
  display: flex;
}
.arrow {
  width: 6.666vh;
  height: 3.701vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #1d1d1b;
  border-radius: 4px 0 0 4px;
  cursor: pointer;
}
.arrow img {
  width: 1.111vh;
  height: 2.222vh;
}
.arrow:last-child {
  border-radius: 0 4px 4px 0;
  border-left: 1px solid #464646;
}
.arrow:last-child img {
  transform: rotate(180deg);
}
.add-btn span {
  font-size: 2.5vh;
  line-height: 1.7777vh;
  margin-right: 1.111vh;
  height: 1.7vh;
}
.add-campaign {
  background: transparent;
  border: 1px solid #1d1d1b;
  border-radius: 1.5vh;
  font-size: 2.3vh;
  margin: 3.3vh 3.2vh 0 0;
  padding: 2vh 0;
  text-align: center;
  transition: 0.3s;
  cursor: pointer;
  color: #1d1d1b;
  width: 56.9vh;
}

.campaign-card-container {
  width: auto;
}

.campaigns-manager {
  display: flex;
}

.add-campaign:hover {
  background: #1d1d1b;
  color: #ededed;
  border: 1px solid #1d1d1b;
}

.add-campaign-block {
  border-radius: 1.5vh;
  margin-top: 1.7vh;
  max-height: 77vh;
  overflow-y: auto;
  background: #1d1d1b;
  width: 54vh;
  padding: 2.3vh;
}

.campain-container {
  flex-wrap: wrap;
  width: 117.1vh;
  margin: 0 auto;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

.add-campaign-row {
  display: flex;
  align-items: center;
}

.add-campaign-block input {
  text-align: left;
  width: 100%;
}

.add-campaign-actions {
  position: relative;
  top: 0;
}

.add-campaign-period {
  color: #ededed;
  display: flex;
}

.campaign-list {
  /* display: flex;
  flex-flow: column wrap; */
}

.add-divider {
  margin: 0 1vh;
}
.description {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
}
.label {
  font-size: 1.6666666666666667vh;
  line-height: 1.8888888888888888vh;
  color: #908f8d;
  width: 100%;
}

.number {
  font-size: 3.3333333333333335vh;
  line-height: 3.888888888888889vh;
  color: #ededed;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.number span {
  color: #908f8d;
}
.stat-row {
  display: flex;
}
.stat-row .stat-row-col {
  width: 48%;
  margin-right: 2.22vh;
}
.stat-row .stat-row-col:last-child {
  margin-right: 0;
}
.iqos-transparent .container-box {
  background: transparent;
}
</style>
